<template>
    <v-alert
        type="info"
        color="primary"
        variant="outlined"
        colored-border
        class="mt-4"
        style="border-color: #f9b12a !important; border-radius: 15px"
    >
        <p><strong>Votre compte a bien été crée.</strong></p>
        <p>Un mail pour renseigner votre mot de passe vous a été envoyé.</p>
        <p>Pensez à vérifier dans vos spams.</p>
        <p>Cliquer sur le bouton pour revenir à l'écran de connexion.</p>
    </v-alert>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class EndRegisterPage extends Vue {}

export default toNative(EndRegisterPage);
</script>
